<style src="./Promo.scss" lang="scss"></style>

<template lang="pug">
  .promo(
    v-if="content && visible"
    :class='classList'
  )
    a.promo__cover(
      :href="banner.url"
      target="_blank"
    )
      img.promo__image(
        :src='image'
        :alt='banner.title'
        loading='lazy'
      )
</template>

<script>
import { mapGetters } from "vuex";
import { HOST_URL } from "@/constants";

export default {
  props: {
    type: {
      default: "desktop",
      type: String,
      validator: value => {
        return ["desktop", "mobile"].includes(value);
      }
    }
  },
  data() {
    return {
      view: {
        desktop: "vertical",
        mobile: "horizontal"
      }
    };
  },
  computed: {
    ...mapGetters({
      content: "promo/content",
      loaded: "promo/loaded"
    }),
    classList() {
      return {
        "is-loaded": this.loaded,
        [`is-${this.type}`]: true
      };
    },
    banner() {
      return this.content.payload.banner;
    },
    visible() {
      return Boolean(this.banner.images[this.view[this.type]]);
    },
    image() {
      return `${HOST_URL}${this.banner.images[this.view[this.type]]}`;
    }
  }
};
</script>
